import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_MORE_DETAIL_INFO_DATA = "paginationMoreDetailInfoData";
export const LIST_MORE_DETAIL_INFO_DATA = "listMoreDetailInfoData";
export const GET_MORE_DETAIL_INFO_DATA = "getMoreDetailInfoData";
export const POST_MORE_DETAIL_INFO_DATA = "postMoreDetailInfoData";
export const PUT_MORE_DETAIL_INFO_DATA = "putPMoreDetailInfoData";
export const PUT_MORE_DETAIL_INFO_STATUS_DATA = "putMoreDetailInfoStatusData";
export const DELETE_MORE_DETAIL_INFO_DATA = "deleteMoreDetailInfoData";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";
export const SET_STATE_PRAM_M_DETAIL_INFO = "setStarePramMDetailInfoLocation";


export default {
  state: {
    path: "more_detail_info",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: "",
      data_pram:''
    }
  },
  getters: {},
  actions: {
    [PAGINATION_MORE_DETAIL_INFO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_MORE_DETAIL_INFO_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_MORE_DETAIL_INFO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [POST_MORE_DETAIL_INFO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_MORE_DETAIL_INFO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_MORE_DETAIL_INFO_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_MORE_DETAIL_INFO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_STATE_PRAM_M_DETAIL_INFO](state, payload) {
      state.data_pram = payload;
    },
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
